module.exports = __webpack_public_path__ + "static/media/kleenex.45f64aa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/kleenex.png
// module id = 951
// module chunks = 0